import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [ ],
        formActions: [
            {
                btn_text: '<i class="fas fa-print"></i> Mentés és nyomtatás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveAndPrintEmployabilityOpinion'
            }
        ],
        rowActionsReadOnly: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeDetails'
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow'
            },
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeDetails'
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow'
            },
            {
                btn_text: '<i class="fas fa-history"></i>',
                title: 'Előzmények',
                event_name: "customClick",
                class: "btn btn-outline-purple",
                event_payload: 'showHistory'
            },
            {
                btn_text: '<i class="fas fa-envelope"></i>',
                title: 'E-mail küldése munkavállaló részére',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'emailSendToEmployee',
                additionalButtonVisible: "isDocumentValidatedReopen",
            },
            {
                btn_text: '<i class="fas fa-envelope"></i>',
                title: 'E-mail küldése felettes részére',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'emailSendToSupervisor',
                additionalButtonVisible: "isDocumentValidatedReopen",
            },
        ],
        headerFields: [
            {
                name: "treatment.startDate",
                label: "Kezelés időpontja",
                slot_name: "startDate_format",
                visibility: true,
                formType: "date",
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "siteGroup.name",
                label: "Munkakör",
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "capableStatusId",
                label: "Alkalmasság státusza",
                visibility: false,
                formVisible: true,
                formSize: 3,
                formType: "select",
                formRequired: true,
                selectOptions: {
                    apiCallback: Api.getCapableStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "capableStatus.text",
                label: "Alkalmasság",
                visibility: true,
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "restrictionText",
                label: "Korlátozás",
                visibility: true,
                formVisible: true,
                formSize: 3,
                formType: "textarea",
                viewModalShow: true
            },
            {
                name: "validity",
                label: "Érvényesség",
                visibility: true,
                slot_name: "date_format",
                sort: true,
                formVisible: true,
                formSize: 3,
                formType: "date",
                formRequired: true,
                viewModalShow: true
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                visibility: true,
                formType: "dateTime",
                formVisible: true,
                viewModalShow: true
            },
            {
                name: "validated",
                label: "Státusz",
                visibility: true,
                slot_name: "validated_format",
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
